import http from '../http'
import {API_CONFIG} from '../config'
import {AUTH_URL, MAGIC_LINK_URL, MFA_VERIFY_URL, MFA_RESEND_URL, MFA_CANCEL_URL} from '@/services/endpoints'

export function getToken(authData) {
    return http.request({
        url: AUTH_URL,
        method: 'POST',
        headers: {
            'Authorization': ""
        },
        data: {
            username: authData.username,
            password: authData.password,
            grant_type: 'password',
            client_id: API_CONFIG.CLIENT_ID,
            client_secret: API_CONFIG.CLIENT_SECRET,
            scope: '',
            lang:authData.lang
        }
    })
}
export function verifyMfa(mfaData) {
    return http.request({
        url: MFA_VERIFY_URL,
        method: 'POST',
        headers: {
            'Authorization': ""
        },
        data: {
            mfa_session_token: mfaData.mfa_session_token,
            otp_code: mfaData.otp_code,
            client_id: API_CONFIG.CLIENT_ID,
            client_secret: API_CONFIG.CLIENT_SECRET,
            lang:mfaData.lang
        }
    })
}
export function resendMfaOtp(mfaData) {
    return http.request({
        url: MFA_RESEND_URL,
        method: 'POST',
        headers: {
            'Authorization': ""
        },
        data: {
            mfa_session_token: mfaData.mfa_session_token,
            lang:mfaData.lang
        }
    })
}
export function cancelMfa(mfaData) {
    return http.request({
        url: MFA_CANCEL_URL,
        method: 'POST',
        headers: {
            'Authorization': ""
        },
        data: {
            mfa_session_token: mfaData.mfa_session_token,
            lang:mfaData.lang
        }
    })
}
export function getMagicLinkToken(token) {
    return http.request({
        url: MAGIC_LINK_URL + '/' + token,
        method: 'GET',
        headers: {
            'Authorization': ""
        }
    })
}
